import {
  AnchorError,
  parseIdlErrors,
  ProgramError,
  ProgramErrorStack,
  translateError,
} from '@coral-xyz/anchor'
import { Wallet } from '@coral-xyz/anchor/dist/cjs/provider'
import { ConnectionContext } from '@solana/wallet-adapter-react'
import { Connection, Transaction } from '@solana/web3.js'
import { IDL } from 'hedge-web3'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch } from '../pages/_app'
import {
  setLoadingScreenError,
  setLoadingScreenMessage,
  setLoadingScreenShowing,
  setLoadingScreenTitle,
  setLoadingScreenTransactionSteps,
} from '../reducers/loadingScreenReducer'
import { SystemErrors } from './SystemErrors'
import TransactionStep, { StepStatus } from './TransactionStep'
import { confirmTransaction } from './SignSendConfirmVersionedTransaction'

import mixpanel from 'mixpanel-browser'

async function getLastValidBlockHeight(connection) {
  try {
    const { context: { slot: lastValidBlockHeight } } = await connection.getLatestBlockhashAndContext();
    return lastValidBlockHeight;
  } catch (error) {
    console.error("Error fetching lastValidBlockHeight:", error);
    return null;
  }
}


export async function SignSendConfirmTransaction(
  connection: Connection,
  Wallet: Wallet,
  steps: TransactionStep[],
  dispatch: AppDispatch,
  actionTitle: string
): Promise<string> {
  console.log('SendSendConfirm for Transaction')

  return new Promise<string>(async (resolve, reject) => {
    // Show loading screen
    dispatch(setLoadingScreenTitle(actionTitle))
    dispatch(setLoadingScreenShowing(true))
    dispatch(setLoadingScreenTransactionSteps(steps))

    mixpanel.track('SignSendConfirmTransaction Start', {
      actionTitle,
    })

    // For each transaction
    for (let index = 0; index < steps.length; index++) {
      // const step = steps[index]
      steps[index].status = StepStatus.Building
      dispatch(setLoadingScreenTransactionSteps(steps))

      // Build Transaction
      const transaction = await steps[index].buildTransaction()
      console.log(`Transaction for step`, steps[index].title, transaction)

      if (transaction) {
        // Sign Transactions

        steps[index].status = StepStatus.Signing
        dispatch(setLoadingScreenTransactionSteps(steps))

        await Wallet.signTransaction(transaction)
          .then(async (signedTransaction) => {
            steps[index].status = StepStatus.Submitting
            dispatch(setLoadingScreenTransactionSteps(steps))

            const lastValidBlockHeight = await getLastValidBlockHeight(connection)
            // SEND
            await connection
              .sendRawTransaction(signedTransaction.serialize())
              .then(async (signature) => {
                steps[index].status = StepStatus.Processing
                steps[index].signature = signature
                dispatch(setLoadingScreenTransactionSteps(steps))

                // Wait for processed status
                await confirmTransaction(connection, signature, 'processed')

                steps[index].status = StepStatus.Confirming
                dispatch(setLoadingScreenTransactionSteps(steps))

                // Wait for confirmed status
                await confirmTransaction(connection, signature, 'confirmed')

                steps[index].status = StepStatus.Success
                dispatch(setLoadingScreenTransactionSteps(steps))
                mixpanel.track('SignSendConfirmTransaction Transaction Success', {
                  signature,
                  transactionTitle: steps[index].title
                })
              })
          })
          .catch((error) => {
            steps[index].error = parseErrorMessage(error)
            steps[index].status = StepStatus.Fail
            dispatch(setLoadingScreenTransactionSteps(steps))
            reject(error)
            mixpanel.track('SignSendConfirmTransaction Transaction Failed', {
              transactionTitle: steps[index].title
            })
            index = steps.length
          })

        // // Send and confirm transaction
      } else {
        steps[index].status = StepStatus.Skip
        dispatch(setLoadingScreenTransactionSteps(steps))
      }
    }
    mixpanel.track('SignSendConfirmTransaction Finish', {
      actionTitle,
    })
    resolve('Done')
  })
}

function ToastBody({ signature, title, status, networkConnection, explorer }) {
  const openInExplorer = (event) => {
    event.stopPropagation()
    window.open(
      `${explorer.baseUrl}/tx/${signature}?cluster=${networkConnection.cluster}`,
      '_blank'
    )
  }
  return (
    <div>
      <div>
        <strong>{title}</strong>
      </div>
      <div>{status}</div>
      <div>
        <a href="#" onClick={openInExplorer} className="link-info">
          View in Solana Explorer
        </a>
      </div>
    </div>
  )
}
function mapStateToProps(state) {
  const { networkConnection, explorer } = state.wallet
  return {
    networkConnection,
    explorer,
  }
}

const ConnectedToastBody = connect(mapStateToProps)(ToastBody)

function parseErrorMessage(error: any): string {
  console.log('parseErrorMessage', error)
  console.log('parseErrorMessage', JSON.stringify(error))
  if (!error) {
    return 'No error to parse'
  }
  if (error?.code) {
    console.log('Parsed Error Code:', error.code)
  }
  const parsedError = translateError(error, parseIdlErrors(IDL))
  console.log('Transaction Error:', parsedError)
  console.log('Transaction Error:', JSON.stringify(parsedError))

  if (parsedError?.error?.errorMessage){
    console.log("parsedError?.error?.errorMessage", parsedError?.error?.errorMessage)
    return parsedError?.error?.errorMessage
  }

  const parsedErrorMessage = parseErrorText(parsedError.toString())
  console.log("parsedError.toString()", parsedError.toString())
  if (parsedErrorMessage) {
    console.log('parsedErrorMessage', parsedErrorMessage)
    return parsedErrorMessage
  }
  
  if (error?.message) {
    console.log('error?.message:', error?.message)
    return error.message
  }
}

function parseErrorText(text:string) {
  const search = /error: (0x[0-9a-fA-F]+)/gm
  const match = search.exec(text)
  console.log('match', match)
  if (match && match.length >= 2) {
    console.log('group', match[1])
    const baseTen = parseInt(match[1], 16)
    console.log('baseTen', baseTen)
    if (getErrorMessageForCode(baseTen)) {
      return getErrorMessageForCode(baseTen)
    }
  }
}

function getErrorMessageForCode(code: number) {
  console.log("Checking for error number:", code)
  if (SystemErrors[code]) {
    return SystemErrors[code]
  }
}
